import { NSARouterMakerResult } from "namirasoft-account-react";
import { SMSSenderEntities } from "../SMSSenderEntities";
import { SMSSenderProps } from "../SMSSenderProps";
import { SMSSenderLayout } from "../SMSSenderLayout";
import { NamirasoftMap } from "namirasoft-site-map";

interface SentListPageProps extends NSARouterMakerResult, SMSSenderProps
{ }

export default function SentListPage(props: SentListPageProps)
{
	let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

	return (
		<SMSSenderLayout
			{...props}
			action={{
				title: "Report",
				description: "View detailed reports of the messages sent, including phone number, message, date, and time.",
				menus: {}
			}}
			pages={{
				entity: SMSSenderEntities.sent(props),
				list: {
					ui: {
						search_box: {
							exclude: {
								load_value: (table, column) =>
								{
									if (namirasoft.sms_sender.tables.sent.name === table)
									{
										let columns = [
											namirasoft.sms_sender.tables.sent.columns.message.name,
											namirasoft.sms_sender.tables.sent.columns.result.name,
										]
										return columns.includes(column);
									}
									return false;
								}
							}
						}
					}
				}
			}}
		>
			<></>
		</SMSSenderLayout>
	);
}